import { FormDialogTemplate } from "../../../../shared/form-dialog/form-dialog.template";
import { BehaviorSubject, Subject } from "rxjs";
import { FormBuilder, Validators } from "@angular/forms";
import { Injector } from "@angular/core";

export class CommentDialogTemplate extends FormDialogTemplate {
    title: Subject<string> = new BehaviorSubject<string>(undefined);
    private readonly formBuilder: FormBuilder;

    constructor(private readonly injector: Injector) {
        super();
        this.formBuilder = injector.get(FormBuilder);
        this.editForm = this.formBuilder.group({
            comment: ['', Validators.required]
        })
        this.initilize(this.title, this.editForm, this.userFormTabs);
    }

    userFormTabs = [
        {
            title: "Comments",
            selected: true,
            formControls: [{
                type: 'textarea',
                name: 'comment',
                title: 'Comments',
                stretch: true
            }]
        },
    ]

}
